import React from 'react'
import {
    Button,
    Divider,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Select  
} from '@chakra-ui/react'
import { useFormik } from "formik";
import * as Yup from "yup";

// settlement formik value
const settlementValues = {
    damageAmount: '',
    settlementAmount: '',
    settlementType: ''
}

// settlement Yup Validation schema
const settlementSchema = Yup.object({
    damageAmount: Yup.number().positive("Total rent can't start with a minus (-) Or zero (0)").required("This field is required"),
    settlementAmount: Yup.number().positive("Total rent can't start with a minus (-) Or zero (0)").required("This field is required"),
    settlementType: Yup.string().required("Please select settlement type")
  });

function SettlementForm({onClose}) {
    
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: settlementValues,
      validationSchema: settlementSchema,
      onSubmit: (values, action) => {
        console.log(values)
        onClose()
        action.resetForm()
      },
    });
  return (
    <ModalContent>
    <ModalHeader textAlign={'center'}>Settlement Details</ModalHeader>
    <Divider/>
    <ModalCloseButton />
    <ModalBody pb={6}>

        <FormControl mt={4} isInvalid={errors.damageAmount && touched.damageAmount}>
            <FormLabel>Damage Amount</FormLabel>
            <Input placeholder='Enter damage amount' name='damageAmount'  value={values.damageAmount} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            {errors.damageAmount && touched.damageAmount ? (
            <FormErrorMessage>{errors.damageAmount}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.settlementAmount && touched.settlementAmount}>
            <FormLabel>Settlement Amount</FormLabel>
            <Input placeholder='Enter settlement amount' name='settlementAmount' value={values.settlementAmount} onChange={handleChange} onBlur={handleBlur} autoComplete="off"/>
            {errors.settlementAmount && touched.settlementAmount ? (
            <FormErrorMessage>{errors.settlementAmount}</FormErrorMessage>
            ) : null}
        </FormControl>

        <FormControl mt={4} isInvalid={errors.settlementType && touched.settlementType}>
            <FormLabel>Settlement Type</FormLabel>
            <Select name="settlementType" placeholder="Select type" onChange={handleChange} onBlur={handleBlur} value={values.settlementType}> 
                <option value='noDamage'>No Damage</option>
                <option value='minorDamage'>Minor Damage</option>
                <option value='majorDamage'>Major Damage</option>
            </Select>
            {errors.settlementType && touched.settlementType ? (
            <FormErrorMessage>{errors.settlementType}</FormErrorMessage>
            ) : null}
        </FormControl>
    </ModalBody>

    <ModalFooter>
         <Button  mr={3} onClick={onClose}>Cancel</Button>
         <Button colorScheme='blue' onClick={handleSubmit}>
             Save
         </Button>
    </ModalFooter>
</ModalContent>
  )
}

export default SettlementForm